import React, { useCallback, useEffect } from 'react'
import { AxiosResponse } from 'axios'
import axiosInstance from '@config/axios'
import { serverPath } from '@constants/api-endpoints'
import { ICrmExpired } from '@dto/crm/crmInfo.dto'
import { useModalContext } from '@context/modalContext'
import VpsExpiredModal from '@components/Modals/VpsExpiredModal/VpsExpiredModal'
import { EUserRoles } from '@enums/roles'
import usePermissions from '@hooks/usePermissions'

const useServerExpired = () => {
  const permission = usePermissions([EUserRoles.SUPER_ADMIN])
  const { setModalComponent } = useModalContext()
  const getServerExpired = useCallback(async () => {
    const { data }: AxiosResponse<ICrmExpired[]> = await axiosInstance.get(
      serverPath.SERVER_EXPIRED,
    )
    if (data?.length) {
      setModalComponent({
        component: (
          <VpsExpiredModal vps={data.map((el) => ({ name: el.name, serverDate: el.serverDate }))} />
        ),
      })
    }
  }, [])

  useEffect(() => {
    if (permission) {
      getServerExpired().then()
      const timer = setInterval(() => {
        getServerExpired().then()
      }, (Number(process.env.REACT_APP_SERVER_EXPIRED_INTERVAL) ?? 30) * 1000 * 60)
      return () => clearInterval(timer)
    }
  }, [])
}

export default useServerExpired
